<template>
  <div class="dot-loader">
    <div class="dot-loader-wrapper">
      <div class="animate-bounce">
        <div class="dot-loader-dot animate-pulse" />
      </div>
      <div class="animate-bounce animation-delay">
        <div class="dot-loader-dot animate-pulse animation-delay" />
      </div>
      <div class="animate-bounce animation-delay">
        <div class="dot-loader-dot animate-pulse animation-delay:" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DotLoader"
};
</script>

<style>
.dot-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3.5rem;
}

.dot-loader-wrapper {
  display: flex;
  gap: 0.5rem;
}

.dot-loader-dot {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 9999px;
  background-color: #eaeaea;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
}

.animate-bounce {
  animation: bounce 1s infinite;
}

@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.animation-delay {
  animation-delay: -0.3s;
}
</style>
